var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "position-relative md",
      attrs: { action: _vm.formAction },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onFormSubmit($event)
        }
      }
    },
    [
      _c("div", {}, [
        _c("div", { class: "input-group " + _vm.searchBlockStyle }, [
          _c("div", { staticClass: "input-group-prepend" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.buttonStyle,
                attrs: { tabindex: "-1" }
              },
              [
                _c("Icon", {
                  attrs: {
                    icon: "simple-line-icons:magnifier",
                    color: _vm.iconcolor,
                    width: _vm.iconsize
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("input", {
            ref: "input",
            staticClass: "form-control border-0 m-auto",
            class: _vm.inputClasses,
            attrs: {
              type: "search",
              autocorrect: "off",
              autocapitalize: "off",
              autocomplete: "off",
              spellcheck: "false",
              required: "",
              maxlength: "512",
              "aria-label": "Search",
              name: "searchTerm",
              placeholder: _vm.placeholderValue
            },
            domProps: { value: _vm.value },
            on: {
              input: _vm.inputValue,
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-prepend" }, [
            _c(
              "button",
              {
                staticClass: "nav-top-customer-link nav-link btn btn-gray",
                attrs: {
                  type: "button",
                  "data-toggle": "collapse",
                  "data-target": _vm.isInspiration
                    ? ""
                    : "#menu-search-mobile-collapse",
                  "aria-expanded": "false",
                  "aria-controls": "menu-search-mobile-collapse"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.handleCancel($event)
                  }
                }
              },
              [_vm._v("\n          cancel\n        ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }